module.exports = {
      id: "uhc_medicare_advantage-usage",
      viewBox: "0 0 867 172",
      url: __webpack_public_path__ + "static/media/sprite-f1c20b00ee075bb56cafa085f462539d.svg#uhc_medicare_advantage-usage",
      toString: function () {
        return this.url;
      }
    }